export const FIELD_REGISTRY: Record<string, { id: string; label: string }> = {
	// <JobGeneralForm />
	// DEPRECATE: "jobs.status": { id: "jobs.status", label: "Status" },
	// ALREADY DEPRECATED: "jobs.tp_tier": { id: "jobs.tp_tier", label: "TP-Stufe" },
	"jobs.title": { id: "jobs.title", label: "Auftragstitel" },
	"jobs.incoming_order_date": {
		id: "jobs.incoming_order_date",
		label: "Eingangsdatum",
	}, // OK
	"jobs.incoming_order_time": {
		id: "jobs.incoming_order_time",
		label: "Eingangszeit",
	},
	"jobs.outgoing_order_date": {
		id: "jobs.outgoing_order_date",
		label: "Ausgangsdatum",
	}, // OK
	"jobs.outgoing_order_time": {
		id: "jobs.outgoing_order_time",
		label: "Ausgangszeit",
	},
	"jobs.incoming_order_datetime": {
		id: "jobs.incoming_order_datetime",
		label: "Eingangsdatum mit Zeit",
	},
	"jobs.outgoing_order_datetime": {
		id: "jobs.outgoing_order_datetime",
		label: "Ausgangsdatum mit Zeit",
	},

	"jobs.tp_value": { id: "jobs.tp_value", label: "TP-Wert" }, // OK

	"jobs.description": { id: "jobs.description", label: "Beschreibung" }, // OK
	"jobs.tooth_color": { id: "jobs.tooth_color", label: "Zahnfarbe" }, // OK

	"jobs.is_ignore_monthly_discount": {
		id: "jobs.is_ignore_monthly_discount",
		label: "Monatsrabatt unterdrücken",
	}, // OK
	"jobs.is_paid_by_patient": {
		id: "jobs.is_paid_by_patient",
		label: "Patient zahlt selbst",
	}, // OK
	"jobs.bank_account_id": { id: "jobs.bank_account_id", label: "Bankkonto" }, // OK
	"jobs.tax_rate": { id: "jobs.tax_rate", label: "MwSt." }, // OK
	"jobs.guarantor_id": { id: "jobs.guarantor_id", label: "Garant" }, // OK
	"jobs.tp_variation": {
		id: "jobs.tp_variation",
		label: "TP-Variation (+/-)",
	}, // OK

	// ProdCountryChoiceSelect with other
	"jobs.prod_country_choice_or_other": {
		id: "jobs.prod_country_choice_or_other",
		label: "Produktionsland",
	}, // OK

	"jobs.inv_covered_by": {
		id: "jobs.inv_covered_by",
		label: "Kostenübernahme",
	}, // OK
	"jobs.insurance": { id: "jobs.insurance", label: "Versicherung" }, // OK

	"jobs.price_list_id": { id: "jobs.price_list_id", label: "Preisliste" },
	"jobs.currency_text": { id: "jobs.currency_text", label: "Währung" },
	"jobs.round_to": { id: "jobs.round_to", label: "Rundung" },

	// <JobPatientSelect />
	patient_select: { id: "patient_select", label: "Patient auswählen" }, // OK

	// patient.core.form.tsx
	"patients.title": { id: "patients.title", label: "Anrede (Patient)" }, // OK
	"patients.first_name": {
		id: "patients.first_name",
		label: "Vorname (Patient)",
	}, // OK
	"patients.last_name": {
		id: "patients.last_name",
		label: "Nachname (Patient)",
	}, // OK
	"patients.code": { id: "patients.code", label: "Code (Patient)" }, // OK
	"patients.birth_date": { id: "patients.birth_date", label: "Geburtsdatum" }, // OK

	// patient.extended.form.tsx
	"patients.street": { id: "patients.street", label: "Strasse" }, // OK
	"patients.city_postal_code_country": {
		id: "patients.city_postal_code_country",
		label: "Ort, PLZ, Land",
	}, // OK (Use CountrySelectShadcn + PostalCodeAndCityInputShadcn)
	"patients.additional_information": {
		id: "patients.additional_information",
		label: "Zusatz",
	}, // OK
	"patients.gender": { id: "patients.gender", label: "Geschlecht" }, // OK
	"patients.ahv_number": { id: "patients.ahv_number", label: "AHV-Nummer" }, // OK

	// Behandler select (inline dropdown)
	practitioner_select: {
		id: "practitioner_select",
		label: "Behandlerauswahl",
	},
};

// Group fields by category for easier selection
export const FIELD_CATEGORIES: Record<string, string[]> = {
	Auftrag: [
		"jobs.incoming_order_datetime",
		"jobs.outgoing_order_datetime",
		"jobs.incoming_order_date",
		"jobs.outgoing_order_date",
		"jobs.description",
		"jobs.tooth_color",
		"jobs.prod_country_choice_or_other",
		"jobs.inv_covered_by",
		"jobs.insurance",
		"jobs.title",
	],
	Verrechnung: [
		"jobs.price_list_id",
		"jobs.currency_text",
		"jobs.round_to",
		"jobs.bank_account_id",
		"jobs.tax_rate",
		"jobs.guarantor_id",
		"jobs.tp_variation",
		"jobs.tp_value",
		"jobs.is_paid_by_patient",
		"jobs.is_ignore_monthly_discount",
	],
	Patient: [
		"patients.title",
		"patients.first_name",
		"patients.last_name",
		"patients.code",
		"patients.birth_date",
		"patients.street",
		"patients.city_postal_code_country",
		"patients.additional_information",
		"patients.gender",
		"patients.ahv_number",
	],
};

// Get available fields based on tab type
export function getAvailableFieldsForTab(tabType: string): string[] {
	switch (tabType) {
		case "general":
			// General tabs can have any field
			return Object.keys(FIELD_REGISTRY);

		case "notes":
		case "files":
		case "job_history":
		case "deliveries":
		case "total":
			return [];

		default:
			return [];
	}
}

type FieldTable = "jobs" | "patients" | "practitioners";

/**
 * Columns whose job-page field id is not simply "table.column": selects, composites and
 * date columns that also feed a datetime field.
 */
export const FIELD_ID_FOR_COLUMN: Record<
	FieldTable,
	Record<string, string[]>
> = {
	jobs: {
		patient_id: ["patient_select"],
		practitioner_id: ["practitioner_select"],
		prod_country_choice: ["jobs.prod_country_choice_or_other"],
		prod_country_other: ["jobs.prod_country_choice_or_other"],
		incoming_order_date: [
			"jobs.incoming_order_date",
			"jobs.incoming_order_datetime",
		],
		incoming_order_time: [
			"jobs.incoming_order_time",
			"jobs.incoming_order_datetime",
		],
		outgoing_order_date: [
			"jobs.outgoing_order_date",
			"jobs.outgoing_order_datetime",
		],
		outgoing_order_time: [
			"jobs.outgoing_order_time",
			"jobs.outgoing_order_datetime",
		],
	},
	patients: {
		postal_code: ["patients.city_postal_code_country"],
		city: ["patients.city_postal_code_country"],
		country: ["patients.city_postal_code_country"],
	},
	practitioners: {},
};

export const fieldIdsForColumns = (
	table: FieldTable,
	columns: string[]
): string[] => [
	...new Set(
		columns.flatMap(
			(column) =>
				FIELD_ID_FOR_COLUMN[table][column] ?? [`${table}.${column}`]
		)
	),
];
